import { API_URL } from '../constants';
import { fetch } from '../fetchWrapper/fetch';
import { IGetVenuesResponseBody, IGetVenuesResponseData } from './types';

export const getVenues = async (): Promise<IGetVenuesResponseData[]> => {
  const response = await fetch(`${API_URL}/venues`, {});
  if (!response.ok) {
    throw new Error('Failed to fetch venues');
  }
  const json: IGetVenuesResponseBody = await response.json();
  return json.data;
};
